/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var PropTypes = require("prop-types");
var classnames = require("classnames");
if (!process.env.ALEX_UI_IGNORE_CSS) { require('./FullscreenDropzone.css'); }
var Icon_1 = require("./Icon");
var moduleClassNameFactory_1 = require("./util/moduleClassNameFactory");
var moduleClassName = moduleClassNameFactory_1.moduleClassNameFactory("m-fullscreenDropzone");
var blacklistedBrowsers = [/opera.*Macintosh.*version\/12/i];
var isBrowserBlackListed = function () {
    return blacklistedBrowsers.reduce(function (isBlackListed, regex) {
        return isBlackListed || regex.test(navigator.userAgent);
    }, false);
};
var isBrowserSupported = (function () {
    if (process.env.ALEX_UI_IGNORE_CSS) {
        return true;
    }
    var capableBrowser;
    capableBrowser = true;
    var context = window;
    if (context.File &&
        context.FileReader &&
        context.FileList &&
        context.Blob &&
        context.FormData) {
        if (!("classList" in document.createElement("a"))) {
            capableBrowser = false;
        }
        else if (isBrowserBlackListed()) {
            capableBrowser = false;
        }
    }
    else {
        capableBrowser = false;
    }
    return capableBrowser;
})();
var filterEscKey = function (fn) { return function (e) {
    if (e.keyCode === 27) {
        fn(e);
    }
}; };
var FullscreenDropzone = /** @class */ (function (_super) {
    tslib_1.__extends(FullscreenDropzone, _super);
    function FullscreenDropzone(props) {
        var _this = _super.call(this, props) || this;
        _this.handleDragEnter = _this.handleDragEnter.bind(_this);
        _this.handleDragOver = _this.handleDragOver.bind(_this);
        _this.handleDragLeave = _this.handleDragLeave.bind(_this);
        _this.handleDrop = _this.handleDrop.bind(_this);
        _this.handleCancel = _this.handleCancel.bind(_this);
        _this.handleEsc = filterEscKey(_this.handleCancel);
        _this.state = {
            visible: false
        };
        return _this;
    }
    FullscreenDropzone.prototype.componentDidMount = function () {
        if (isBrowserSupported) {
            this.addEventListeners();
        }
    };
    FullscreenDropzone.prototype.componentWillUnmount = function () {
        if (isBrowserSupported) {
            this.removeEventListeners();
        }
    };
    FullscreenDropzone.prototype.addEventListeners = function () {
        window.addEventListener("dragenter", this.handleDragEnter);
        if (this.zone) {
            this.zone.addEventListener("dragover", this.handleDragOver);
            this.zone.addEventListener("dragleave", this.handleDragLeave);
            this.zone.addEventListener("drop", this.handleDrop);
            this.zone.addEventListener("dragend", this.handleDrop);
        }
    };
    FullscreenDropzone.prototype.removeEventListeners = function () {
        window.removeEventListener("dragenter", this.handleDragEnter);
        if (this.zone) {
            this.zone.removeEventListener("dragover", this.handleDragOver);
            this.zone.removeEventListener("dragleave", this.handleDragLeave);
            this.zone.removeEventListener("drop", this.handleDrop);
            this.zone.removeEventListener("dragend", this.handleDrop);
        }
    };
    FullscreenDropzone.prototype.handleDragOver = function (e) {
        e.dataTransfer.dropEffect = "copy";
        return false;
    };
    FullscreenDropzone.prototype.handleDragEnter = function (e) {
        e.stopPropagation();
        e.preventDefault();
        window.addEventListener("mouseout", this.handleCancel);
        window.addEventListener("blur", this.handleCancel);
        window.addEventListener("keydown", this.handleEsc);
        this.setState({
            visible: true
        });
    };
    FullscreenDropzone.prototype.handleDragLeave = function (e) {
        if (e.target === this.refs.zone) {
            e.stopPropagation();
            e.preventDefault();
            this.handleCancel();
        }
    };
    FullscreenDropzone.prototype.handleDrop = function (e) {
        e.preventDefault();
        this.handleCancel();
    };
    FullscreenDropzone.prototype.handleCancel = function () {
        window.removeEventListener("mouseout", this.handleCancel);
        window.removeEventListener("blur", this.handleCancel);
        window.removeEventListener("keydown", this.handleEsc);
        this.setState({
            visible: false
        });
    };
    FullscreenDropzone.prototype.render = function () {
        var _this = this;
        if (!isBrowserSupported) {
            return null;
        }
        var _a = this.props, label = _a.label, children = _a.children, className = _a.className;
        var cssClasses = [moduleClassName(), className];
        if (this.state.visible) {
            cssClasses.push(moduleClassName("isVisible"));
        }
        return (React.createElement("div", tslib_1.__assign({ ref: function (element) { return (_this.zone = element); }, className: classnames(cssClasses) }, this.props),
            React.createElement("div", { className: moduleClassName("content") },
                React.createElement(Icon_1.Icon, { type: "drag-drop-large", size: 5, color: "white" }),
                React.createElement("div", { className: moduleClassName("label") }, label),
                React.createElement("div", { className: moduleClassName("children") }, children))));
    };
    FullscreenDropzone.propTypes = {
        label: PropTypes.string.isRequired,
        className: PropTypes.string
    };
    return FullscreenDropzone;
}(React.Component));
exports.FullscreenDropzone = FullscreenDropzone;